//
//
//
//
//
//
//
//
//
export default {
  methods: {
    handleNewError: function handleNewError() {
      console.log(a); // eslint-disable-line
    }
  }
};